import { cn } from "@/utils/utils";
import { X } from "lucide-react";
import { useBanner } from "..";
import Markdown from 'react-markdown'

export const Banner = () => {
  const banner = useBanner();

  return (
    <div className={cn("bg-musio-blue min-h-11 flex items-center justify-center relative w-auto font-inter", banner.visible ? "" : "hidden")}>
      <X
        className="w-4 h-4 absolute right-0 m-4 cursor-pointer"
        onClick={() => banner.toggleVisible()}
      />
      <div
        className="text-xs font-light md:text-sm"
      >
        <Markdown
          components={{
            strong: ({ node, ...props }) => (
              <strong className="font-bold" {...props} />
            ),
            a: ({ node, ...props }) => (
              <a className="underline" {...props} />
            ),
          }}
        >
          {banner.bannerMessage}
        </Markdown>
      </div >
    </div >
  );
};

export default Banner;
